import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import {useRqGetAiVoicePersons} from '../../react_query/sponsor_commercial/SponsorCommercialQuery';
import React, {useCallback} from 'react';

type ISelectAiVoicePersonProps = {
  companyId: number;
  selectedAiVoicePerson: number;
  setSelectedAiVoicePerson: React.Dispatch<React.SetStateAction<number>>;
  disabled: boolean;
};

export const SelectAiVoicePersons = ({
  companyId,
  setSelectedAiVoicePerson,
  selectedAiVoicePerson,
  disabled,
}: ISelectAiVoicePersonProps) => {
  const {data, isFetching} = useRqGetAiVoicePersons(companyId);

  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      setSelectedAiVoicePerson(Number(event.target.value));
    },
    [setSelectedAiVoicePerson],
  );

  return (
    <FormControl className='w-300'>
      <InputLabel id={`ai-voice-person`}>{`Ai Voice`}</InputLabel>
      <Select
        disabled={disabled}
        labelId={`ai-voice-person`}
        label={'AI Voice'}
        SelectDisplayProps={{
          'aria-controls': undefined,
        }}
        value={`${selectedAiVoicePerson || ''}`}
        onChange={handleChange}>
        <MenuItem disabled>{'Choose AI Voice'}</MenuItem>
        {!isFetching &&
          data &&
          data.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
